/**
 * Created by Sandon on 2019-07-03.
 */

export default {
  visible: (state) =>  {
    return state.visible
  }
}
